import React from "react";
import styled from "styled-components";

export default styled.img`
    height: 40px;
    max-width: 80%;
`;